module.exports = __webpack_public_path__ + "img/gameover_bg.3dfceb96.jpg";